import { Space, Modal, Form, Input, Button, Row, Col, Radio, Card, Tooltip, message } from "antd";
import { SearchOutlined, ReloadOutlined, DownloadOutlined, CloudUploadOutlined, ExclamationCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import PriceEditTable from "../components/PriceEditTable";
import BatchPriceUpdate from "../components/BatchPriceUpdate";
import UploadHistory from "../components/UploadHistory";
import BatchUploadModal from "../components/BatchUpload";
import UpdateRecord from "../components/UpdateRecord";
import ShopSelect from '../../../components/BaseInfoSelects/StoreSelectBase'
import CategorySelect from "../../../components/CategorySelect";
import AuthComponent from "../../../components/AuthComponent";
import service from "../../../@services";
import * as Utils from '../../../@utils'
import cloneDeep from 'lodash/cloneDeep'
const statusMap = {
  '1':"下架",
  '0': "上架",
  '2': "紧急下架",
  '3': "可售",
}
export default function PriceManagement(props) {
  const [form] = Form.useForm();
  const [historyModalVisible, setUploadHistoryVisible] = useState(false)
  const [priceModalVisible, setBatchPriceVisible] = useState(false)
  const [updateModalVisible, setUpdateRecordVisible] = useState(false)
  const [batchUploadProps, setBatchUpload] = useState({visible:false})
  const [selectedRowKeys, onSelectChange] = useState([])
  const [storeId,onSelectStore] = useState("")
  const [loading, setLoading] = useState(false)
  const [dataSource, setTableData] = useState([])
  const [batchTableData, setBatchTableData] = useState([])
  const [skuForStoreId, setSkuId] = useState("")
  const [pagination, setPagination] = useState({})
  useEffect(() => {
    onSearch()
  }, [storeId]);
  const setDefaultStore = (res)=>{
    form.setFieldsValue({
      storeId: res.id
    })
    onSelectStore(res.id)
  }
  const onSearch = () => {
    if(!storeId){
      //message.warning('请选择门店');
      return
    }
    const params = Object.assign({pageIndex: 1, pageSize: 10},form.getFieldsValue())
    fetchData(params)
  }
  const handleTableChange = (pagination) => {
    setPagination(pagination)
    const params = Object.assign({},form.getFieldsValue(),{ pageIndex: pagination.current, pageSize: pagination.pageSize})
    fetchData(params)
  }
  const fetchData = async (params) => {
    setLoading(true)
    if(params.categoryCode instanceof Array) params.categoryCode = null
    const data = await service.price.getPricePageList(params)
    setLoading(false)
    if(data){
      setTableData(data.result)
      setPagination({
        showSizeChanger: true,
        showQuickJumper: true,
        current: data.pageIndex,
        pageSize: data.pageSize,
        total: data.recordCount
      })
    }
  }
  const onReset = (values) => {
    form.resetFields();
  };
  const updatePrice = async (row) => {
    if(!row) return
    if (row.length == 0){
      message.warning('未调整价格，请调价')
      return
    }
    let list = Array.isArray(row)
    ? row.map(item=>{
      return {
        currentPrice: item.currentPrice,
        skuForStoreId: item.skuForStoreId,
        storeId: storeId
      }
    })
    : [{
      currentPrice: row.currentPrice,
      skuForStoreId: row.skuForStoreId,
      storeId: storeId
    }]
    Modal.confirm({
      title: '提示',
      icon: <ExclamationCircleOutlined />,
      content: '确认是否提交该销售价，提交后审核成功即可生效',
      okText: '确认',
      cancelText: '取消',
      onCancel: ()=>onSearch(),
      onOk: ()=>{
        service.price.batchUpdateProductPrice({list}).then(data=>{
          if(data&&data.errInfo){
            Modal.confirm({
              title: '提示',
              icon: <ExclamationCircleOutlined />,
              content: <>{data.errInfo.map(item=>{return <div key={item.skuForStoreId}>{item.goodsCode}--&yen;{item.newPrice}</div>})}<div>提交失败，商品新销售价正在审核中，请勿重复提交～</div></>,
              okText: '确认',
              cancelText: '取消'
            });
          }else{
            message.success('价格已经提交审核，请耐心等待！');
            setBatchPriceVisible(false)
            onSearch()
          }
        })
      }
    });
  }
  const batchSetSaliPrice = () => {
    if(selectedRowKeys.length===0){
      message.warning('请选择商品');
      return
    }
    const list = dataSource.filter(item=>{return selectedRowKeys.indexOf(item.skuForStoreId)>=0})
    const bb = cloneDeep(list);
    setBatchTableData(bb)
    setBatchPriceVisible(true)
  }
  const getUpdateReord = async (skuForStoreId) => {
    setSkuId(skuForStoreId)
    setUpdateRecordVisible(true)
  }
  const selectCategory = (value,selectedOptions) =>{
    if(selectedOptions.length>0){
      form.setFieldsValue({
        categoryCode: selectedOptions[selectedOptions.length-1].categoryCode
      })
    }
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const exportProduct = async () => {
    const params = Object.assign({},form.getFieldsValue())
    const file = await service.price.exportProductPrice(params)
    const filename = '商品价格报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  };
  const closeUpload = () => {
    setBatchUpload({visible:false})
    onSearch()
  }
  const auditPrice = (auditNo,status) => {
    props.history.push(`/product/price-adjust/page?auditNo=${auditNo}&status=${status}`)
  }
  const columns = [
    { title: '序号', dataIndex: '', key: 'index', render: (text,record,index)=> index+1 },
    { title: '商品信息', dataIndex: 'goodsName', key: 'goodsName', render: (text,record)=> (
      <span style={{fontSize: '12px'}}>
        <Row>
          <Col style={{color: '#3e9eff'}}>{record.goodsName}</Col>
        </Row>
        <Row>
          <Col>商品编码：{record.goodsCode}</Col>
        </Row>
        <Row>
          <Col>商品条码：{record.barCode}</Col>
        </Row>
      </span>
    )},
    { title: '商品类别', dataIndex: 'categoryName', key: 'categoryName' },
    { title: '规格', dataIndex: 'spec', key: 'spec' },
    { title: '单位', dataIndex: 'unit', key: 'unit' },
    { title: ()=>{
        return (<Tooltip title="移动平均价">成本价 <ExclamationCircleFilled /></Tooltip>)
      }, dataIndex: 'moveAveragePrice', key: 'moveAveragePrice', render: (text, record) =>text?<span>{text}</span>:<span>-</span>
    },
    { title: '零售指导价', dataIndex: 'guidePrice', key: 'guidePrice', render: (text, record) =>text?<span>{text}</span>:<span>-</span> },
    { title: '当前销售价', dataIndex: 'currentPrice', key: 'currentPrice' },

    { title: ()=>{
       return (<Tooltip title="毛利率=（当前销售价-成本价）/当前销售价*100%">毛利率% <ExclamationCircleFilled /></Tooltip>)
      }, dataIndex: 'profitView', key: 'profitView', render: (text, record) =>text?<span>{text}%</span>:<span>-</span>},
    { title: '更新时间', dataIndex: 'date', key: 'date' },
    { title: '商品状态', dataIndex: 'status', key: 'status', render: (status)=> (
        statusMap[status]
      )
    },
    {
      title: '操作',
      dataIndex: '',
      key: 'x',
      render: (text,record,index) => (
        <AuthComponent authKey="/product/price/view-update-record">
        <Button type="link" onClick={()=>getUpdateReord(record.skuForStoreId)}>调价记录</Button>
        </AuthComponent>
      ),
    },
  ];
  return (
    <Space
      direction="vertical"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <Card>
        <Form
          form={form}
          layout="inline"
        >
          <Form.Item name="storeId" label="所属门店">
            <ShopSelect style={{ width: 180 }} keyVal='id' OnOptionsLoad={setDefaultStore} onChange={onSelectStore} />
          </Form.Item>
          <Form.Item name="categoryCode" label="商品类别">
            <CategorySelect
              style={{ width: 180 }}
              onChange={selectCategory}
            />
          </Form.Item>
          <Form.Item name="goodsInfoStr" label="商品信息">
            <Input style={{ width: 180 }} placeholder="商品名称/条码/商品编码" />
          </Form.Item>
          <Form.Item name="status" label="商品状态">
            <Radio.Group>
              <Radio value={0}>全部</Radio>
              <Radio value={3}>可售</Radio>
              <Radio value={2}>已下架</Radio>
              <Radio value={1}>已上架</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/price/page">
              <Button type="primary" ghost icon={<SearchOutlined />} onClick={onSearch}>查询</Button>
            </AuthComponent>
          </Form.Item>
          <Form.Item>
            <AuthComponent authKey="/product/price/page">
              <Button type="primary" ghost icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
            </AuthComponent>
          </Form.Item>
        </Form>
      </Card>
      <Card style={{ height: "100%", flexGrow: 1 }}>
        <Space style={{ display: "flex", justifyContent: "space-between", padding: "15px 0", marginTop: "-24px" }}>
          <Space>
            <AuthComponent authKey="/product/price/batch-update-price">
            <Button type="primary" onClick={batchSetSaliPrice}>批量设置销售价</Button>
            </AuthComponent>
            <AuthComponent authKey="/product/price/import-price">
            <Button type="primary" onClick={()=>setBatchUpload({visible:true,taskType: 2})}>Excel导入</Button>
            </AuthComponent>
            <AuthComponent authKey="/product/price/export">
            <Button type="primary" icon={<DownloadOutlined />} onClick={exportProduct}>导出</Button>
            </AuthComponent>
          </Space>
          <AuthComponent authKey="/product/price/page">
          <Button type="link" icon={<CloudUploadOutlined />} onClick={()=>setUploadHistoryVisible(true)}>导入记录</Button>
          </AuthComponent>
        </Space>
        <PriceEditTable
          tableData={dataSource}
          rowSelection={rowSelection}
          pagination={pagination}
          tableColumns={columns}
          loading={loading}
          updatePrice={updatePrice}
          onChange={handleTableChange}
        />
      </Card>
      <UpdateRecord visible={updateModalVisible} skuForStoreId={skuForStoreId} close={()=>{setUpdateRecordVisible(false)}} auditPrice={auditPrice}></UpdateRecord>
      <UploadHistory visible={historyModalVisible} type={[2]} close={()=>{setUploadHistoryVisible(false)}}></UploadHistory>
      <BatchPriceUpdate
        visible={priceModalVisible}
        dataSource={batchTableData}
        close={()=>{setBatchPriceVisible(false)}}
        batchUpdatePrice={updatePrice}
      >
      </BatchPriceUpdate>
      <BatchUploadModal visible={batchUploadProps.visible} taskType={batchUploadProps.taskType} storeId={storeId} close={closeUpload}/>
    </Space>
  );
}
